'use strict';
import React from 'react';

const PrintHeader = () => {
    return (
        <div className="col-xs-12 relative-column">
           <img src="https://upload.wikimedia.org/wikipedia/en/thumb/5/5c/CBRE_Group_logo.svg/1024px-CBRE_Group_logo.svg.png" />
            <a href="http://www.cbre.com/real-estate-services/real-estate-industries/fasb-iasb" className="logo-link">
                Lease Accounting Calculator Results
            </a>
        </div>
    );
};
export default PrintHeader;